import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const Home = () => {
  const { user } = useSelector((state) => state.userInfo);

  if (!user || Object.keys(user).length === 0) return <Navigate to="/login" />;
  // if ((user.role || []).includes('seller')) return <Navigate to="/seller/dashboard" />;
  // if ((user.role || []).includes('brand')) return <Navigate to="/brand/dashboard" />;
  if ((user.role || []).includes('seller')) return <Navigate to="/seller/brand-catalog" />;
  if ((user.role || []).includes('brand')) return <Navigate to="/brand/products" />;
  if ((user.role || []).includes('none')) return <Navigate to="/signup" />;

  return <Navigate to="/unauthorized" />;
};

export default Home;
